var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "water-counter__content" }, [
    _c("div", { staticClass: "water-counter" }, [
      _c("div", { staticClass: "water__drank" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("profile.home.drankWater")))]),
        _vm._v(" "),
        _c("div", { staticClass: "water__value" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.waterValue) +
              " " +
              _vm._s(_vm.$t("profile.home.ml")) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "water__allowed" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("profile.home.dailyAllowance")))]),
        _vm._v(" "),
        _c("div", { staticClass: "water__value" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.allowedWater,
                expression: "allowedWater"
              }
            ],
            attrs: { type: "number", min: "0", max: "10000" },
            domProps: { value: _vm.allowedWater },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.allowedWater = $event.target.value
                },
                _vm.handleInput
              ]
            }
          }),
          _vm._v(" " + _vm._s(_vm.$t("profile.home.ml")) + "\n      ")
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "water__portions" },
      _vm._l(_vm.waterPortions, function(portion, i) {
        return _c("div", { staticClass: "portion" }, [
          _c("div", { staticClass: "portion__info" }, [
            _c("img", {
              attrs: {
                src:
                  "/media/inpulse-template-ac-new-a/profile/water/" +
                  (i + 1) +
                  ".png",
                alt: "glass of water",
                draggable: "false"
              }
            }),
            _vm._v(
              "\n\n        " +
                _vm._s(portion) +
                " " +
                _vm._s(_vm.$t("profile.home.ml")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "portion__action",
              class: { action_disabled: !_vm.isToday },
              on: {
                click: function() {
                  return _vm.isToday && _vm.addWater(portion)
                }
              }
            },
            [
              _c("img", {
                attrs: {
                  src:
                    "/media/inpulse-template-ac-new-a/profile/water/plus.svg",
                  alt: "plus"
                }
              }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("profile.home.add")) + "\n      "
              )
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }